import { NodeViewWrapper } from "@tiptap/react"
import { useEffect, useState } from "react";
import { getTopRatedReview } from '../../../../../api/reviewApi';
import fillStar from '../../../../../assets/images/icon-fillStar.png'
import emptyStar from '../../../../../assets/images/icon-emptyStart.png'
import halfStar from '../../../../../assets/images/icon-halfFillStar.png'

export const ReviewBlockView = (props) => {
    const { editor, getPos } = props;
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                setLoading(true);
                const response = await getTopRatedReview();
                setReviews(response?.data || []);
            } catch (error) {
                console.error('Error fetching top rated reviews:', error);
                setReviews([]);
            } finally {
                setLoading(false);
            }
        };
        fetchReviews();
    }, []);

    const handleCaptionClick = () => {
        const nodePosition = getPos();
        editor.commands.setNodeSelection(nodePosition);
    };

    const renderStars = (rating) => {
        const stars = [];

        for (let i = 1; i <= 5; i++) {
            if (rating >= i) {
                // Full star
                stars.push(
                    <img
                        key={i}
                        src={fillStar}
                        alt="full star"
                        className="review-star"
                    />
                );
            } else if (rating >= i - 0.5) {
                // Half star
                stars.push(
                    <img
                        key={i}
                        src={halfStar}
                        alt="half star"
                        className="review-star"
                    />
                );
            } else {
                // Empty star
                stars.push(
                    <img
                        key={i}
                        src={emptyStar}
                        alt="empty star"
                        className="review-star"
                    />
                );
            }
        }

        return stars;
    };

    const roundToHalfForTotal = (num) => {
        return Math.ceil(num * 2) / 2;
    };


    return (
        <>
            <NodeViewWrapper data-type='reviewBlock'>
                <div className="review-node-wrapper"
                    data-type="reviewBlock"
                >
                    <div onClick={handleCaptionClick}>
                        {loading ? (
                            <div className={`ringLoader loaderContinue`}></div>
                        ) : (
                            <div className='review-content'>
                                <div className='review-grid'>
                                    {reviews?.slice(0, 3)?.map((review, index) => (
                                        <div key={index} className='review-item'>
                                            <div className='review-stars'>
                                                {renderStars(roundToHalfForTotal(review?.averageRating))}
                                            </div>
                                            <div className='review-description'>
                                                “{review?.review}”
                                            </div>
                                            <div className='review-name'>
                                                {review?.name}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </NodeViewWrapper>
        </>
    )
}